import React from "react"
import PropTypes from "prop-types"

import { withStyles } from "@material-ui/core/styles"

import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"

import ReactContainer from "../ReactContainer"
//import Link from '@material-ui/core/Link';
import backgroundImage from "../../../content/assets/com1-alt.jpg"

const styles = (theme) => ({
  gridContainer: {
    alignItems: "center",
    height: "80vh",
    [theme.breakpoints.up("md")]: {
      height: "50vh",
    },
  },
  mainFeaturedPost: {
    position: "relative",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    //marginBottom: theme.spacing(4),
    backgroundImage: `url(${backgroundImage})`, //'url(https://source.unsplash.com/user/erondu)',
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    // [theme.breakpoints.up("sm")]: {
    // //height: '60vh', // `calc(100vh - 60px)`,
    // minHeight: 480,
    // maxHeight: 1300,
    // [> Create the parallax scrolling effect <]
    // backgroundAttachment: "fixed",
    // },
  },
  mainFeaturedPostContent: {
    position: "relative",
    padding: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(6),
      paddingRight: 0,
    },
    // [theme.breakpoints.up("lg")]: {
    // marginTop: theme.spacing(4),
    // },
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: "rgba(0,0,0,.4)",
  },
  subtitle: {
    //lineHeight: "1.5",
    //fontSize: "1.7em",
    //backgroundColor: "rgba(0,0,0,.2)",
    // backgroundColor: theme.palette.primary.dark,
    padding: theme.spacing(1, 5),
    [theme.breakpoints.down("md")]: {
      fontSize: "1.2em",
    },
  },
  title: {
    fontWeight: 700,
    lineHeight: 1.1,
    letterSpacing: 1.8,
    backgroundColor: "rgba(0,0,0,.2)",
    // backgroundColor: theme.palette.primary.dark,
    padding: theme.spacing(1, 5, 0, 5),
    [theme.breakpoints.down("md")]: {
      fontSize: "2.2em",
    },
  },
})

const HomePageHero = ({ classes }) => (
  <Paper className={classes.mainFeaturedPost}>
    <ReactContainer>
      {/* Increase the priority of the hero background image */}
      {
        <img
          style={{ display: "none" }}
          src={backgroundImage}
          //src="https://source.unsplash.com/user/erondu"
          alt="background"
        />
      }
      <div className={classes.overlay} />
      <Grid container className={classes.gridContainer}>
        <Grid item md={6}>
          <div className={classes.mainFeaturedPostContent}>
            <Typography
              component="h1"
              variant="h3"
              color="inherit"
              gutterBottom
              className={classes.title}
            >
              NUS Data System Research Group
            </Typography>

            <Typography
              variant="h5"
              color="inherit"
              paragraph
              className={classes.subtitle}
            >
              Our research interests include data systems, distributed and
              blockchain systems, machine learning and large scale analytics
            </Typography>
          </div>
        </Grid>
      </Grid>
    </ReactContainer>
  </Paper>
)

HomePageHero.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(HomePageHero)
